var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[(_vm.office)?[_c('SiteMasthead',{attrs:{"mini":"true","title":'About ' + _vm.office.FranchiseName,"darken":"true"}}),_c('ContentRow',[_c('ContentContainer',[_c('RichText',{attrs:{"content":_vm.office.About}})],1)],1)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }